import React, { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { Paper, TextButton } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import Responsive from '../../../../../../ui/utils/Responsive';

interface ISelectCardHeaderProps {
	canAddNewCard?: boolean;
	onClickAddNewCard: (e: MouseEvent) => void;
}

export const SelectCardHeader = ({
	canAddNewCard,
	onClickAddNewCard,
}: ISelectCardHeaderProps) => {
	const { t } = useTranslation();

	return (
		<Paper>
			<h3>{t('payment_select_card_header')}</h3>
			<hr />
			<TextWrap>
				<p>{t('payment_select_card_description')}</p>
				{canAddNewCard && <AddNewCard onClick={onClickAddNewCard} />}
			</TextWrap>
		</Paper>
	);
};

const TextWrap = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;

	p {
		max-width: 440px;
		margin-right: 16px;

		&:last-of-type {
			margin-bottom: 0;
		}
	}

	${TextButton} {
		flex-shrink: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: block;

		p {
			margin-right: 0;

			&:last-of-type {
				margin-bottom: 16px;
			}
		}
	}
`;

interface IAddNewCardProps {
	onClick: (e: MouseEvent) => void;
}

const AddNewCard = ({ onClick }: IAddNewCardProps) => {
	const { t } = useTranslation();
	return (
		<TextButton variant="highlight" onClick={onClick}>
			{t('payment_select_card_add_new_button')}
		</TextButton>
	);
};
